// extracted by mini-css-extract-plugin
module.exports = {"name":"CampaignListItem_name__tVGWJ"};